import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import { browserHistory }   from 'react-router';

let Quote = require('../Managers/Quote.js');
let HttpService = require('../Managers/HttpService');

class BeginApplication extends Component {
    componentWillMount() {
        // Clear localStorage to prevent anomalies
        window.localStorage.clear();

        let uuidFormat = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        if ( ! this.props.params.linkref || ! uuidFormat.test(this.props.params.linkref)) {
            // No linkref = error page
            browserHistory.push('/error/no-auth');
            return false;
        } else {
            // wire up the link ref, and then load up the application
            // that is tied to this linkref
            HttpService.setLinkRef(this.props.params.linkref);

            // start the promise chain
            HttpService.getRetrieveApplication(HttpService.getLinkRef())
            .then((data) => {
                // we manually set the product ID back in as a top level, as the IRIS
                // API complains if we dont
                if (data.product.productId) {
                    data.productId = data.product.productId;
                }

                // on a retrieval of the application,
                // - save the application to local storage
                // - We default 'check' the phone and post marketing preferences option,
                //   so save that to localStorage in the first instance.
                // - Set manual for signaturePreference
                window.localStorage.setItem('BaseIndividualApplication', JSON.stringify(data));
                Quote.set('signaturePreference', 2, 'BaseIndividualApplication');
                return data;
            })
            .then(() => {
                window.localStorage.setItem('applicationId', Quote.get('applicationId', 'BaseIndividualApplication'));
            })
            .then(() => {
                // the getPrivateLegalTexts saves to local storage directly once its complete
                return HttpService.getPrivateLegalTexts(HttpService.getLinkRef());
            })
            .then(() => {
                document.getElementById('copyright-notice').innerHTML = Quote.getByPath('domainInfo.copyrightNotice');
                document.getElementById('mainPhone').innerHTML = Quote.getByPath('domainInfo.generalTelephone');
            })
            .then(() => {
                // Log the IP address for the applicant
                HttpService.getIp('BaseIndividualApplication.ipAddress');

                // remove the applicationId so it can be submitted and redirect
                Quote.set('applicationId', null, 'BaseIndividualApplication');

                // If we cannot retrieve marketing preferences for phone and
                // post from the BaseIndividualApplication, we force it to true.
                if (window.uornorb(Quote.getByPath('BaseIndividualApplication.canContactApplicantByPhoneAndPost'))) {
                    Quote.set('canContactApplicantByPhoneAndPost', true, 'BaseIndividualApplication');
                }

                // If we cannot retrieve marketing preferences for sms and email
                // from the BaseIndividualApplication, we force it to false.
                if (window.uornorb(Quote.getByPath('BaseIndividualApplication.canContactApplicantBySMSAndEmail'))) {
                    Quote.set('canContactApplicantBySMSAndEmail', false, 'BaseIndividualApplication');
                }

                browserHistory.push('/application/declaration');
            })
            .catch(error => {
                if (error == 'GET TERMS AND CONDITIONS ERROR - PRIVATE') {
                    browserHistory.push('/error/domain-info');
                } else {
                    browserHistory.push('/error/application-submitted');
                }
            });
        }
    }

    render() {
        return(
            <div className="loading">
                <div className="spinner">
                    <p><strong>Loading, please wait</strong></p>
                    <div className="bounce1" />
                    <div className="bounce2" />
                    <div className="bounce3" />
                </div>
            </div>
        );
    }
}

BeginApplication.propTypes = {
    params: PropTypes.object,
};

export default BeginApplication;


// WEBPACK FOOTER //
// ./src/components/Screens/BeginApplication.js